
import { useNavigate } from 'react-router-dom';

export function FeaturedListings() {
  const navigate = useNavigate();

  const featuredProperties = [
    {
      id: 1,
      image: "https://public.readdy.ai/ai/img_res/bcfd9b6d0de4a1fd7932b2ed7130605d.jpg",
      price: "$875,000",
      address: "1234 Maple Grove Drive, Birmingham, MI",
      beds: 4,
      baths: 3,
      sqft: "3,200",
      type: "Single Family"
    },
    {
      id: 2,
      image: "https://readdy.ai/api/search-image?query=Contemporary%20townhouse%20with%20modern%20facade%2C%20professional%20real%20estate%20photography%2C%20urban%20setting%2C%20clean%20lines%2C%20attractive%20entrance%2C%20well-maintained%20exterior%2C%20premium%20residential%20development&width=400&height=300&seq=featured2&orientation=landscape",
      price: "$425,000",
      address: "567 Downtown Loft, Royal Oak, MI",
      beds: 2,
      baths: 2,
      sqft: "1,800",
      type: "Townhouse"
    },
    {
      id: 3,
      image: "https://readdy.ai/api/search-image?query=Charming%20colonial%20style%20home%20with%20traditional%20architecture%2C%20professional%20real%20estate%20photography%2C%20mature%20trees%2C%20welcoming%20front%20porch%2C%20classic%20American%20home%20design%2C%20suburban%20neighborhood%20setting&width=400&height=300&seq=featured3&orientation=landscape",
      price: "$650,000",
      address: "890 Oak Street, Troy, MI",
      beds: 5,
      baths: 3,
      sqft: "2,800",
      type: "Colonial"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">Featured Properties</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover exceptional homes in Metro Detroit's most desirable neighborhoods
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {featuredProperties.map((property) => (
            <div key={property.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src={property.image} 
                  alt={property.address}
                  className="w-full h-64 object-cover object-top"
                />
                <button className="absolute top-4 right-4 p-2 bg-white rounded-full shadow-md hover:bg-gray-50 transition-colors">
                  <i className="ri-heart-line text-gray-600"></i>
                </button>
              </div>
              
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-2xl font-bold text-black">{property.price}</h3>
                  <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-sm font-medium">
                    {property.type}
                  </span>
                </div>
                
                <p className="text-gray-600 mb-4">{property.address}</p>
                
                <div className="flex justify-between text-sm text-gray-500 mb-6">
                  <span>{property.beds} beds</span>
                  <span>{property.baths} baths</span>
                  <span>{property.sqft} sqft</span>
                </div>
                
                <button 
                  onClick={() => navigate(`/property-detail/${property.id}`)}
                  className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-colors font-medium whitespace-nowrap cursor-pointer"
                >
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button 
            onClick={() => navigate('/mls-search')}
            className="bg-yellow-400 text-black px-8 py-4 rounded-lg hover:bg-yellow-500 transition-colors font-semibold text-lg whitespace-nowrap cursor-pointer"
          >
            Browse All Properties
          </button>
        </div>
      </div>
    </section>
  );
}
